export const debounce = (func, debounceTime) => {
    const time = debounceTime || 100
    let timer

    return function(event) {
        if (timer) clearTimeout(timer)
        timer = setTimeout(func, time, event)
    }
}

export const templateDetails = () => {
    try {
        const templateName = document.querySelector('[data-template-name]').dataset.templateName
        const templateSuffix = document.querySelector('[data-template-suffix]').dataset.templateSuffix

        return [templateName, templateSuffix]
    } catch (error) {
        console.error(error)
    }
}
